import React from "react";
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent, AlertDialogFooter, AlertDialogHeader,
    AlertDialogOverlay,
    Box, Button,
    SimpleGrid
} from "@chakra-ui/react";
import { useNewCompany } from "./hooks/useNewCompany";
import NewCompanyTable from "./components/Table";
import NewCompanyForm from "./components/Form";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const NewCompaniesScreen = () => {

    const {
        state,
        cancelRef,
        add,
        closeDelete,
        closeError,
        changeInput,
        changeAddressInput,
        changeContactInput,
        showModal,
        saveCompany,
        deleteCompany,
        editCompany,
        displayInputError
    } = useNewCompany();

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <ConditionalRenderer
                conditions={[
                    {
                        condition: state.show,
                        component: (
                            <SimpleConditionalFrame
                                backClick={() => showModal(false)}
                                title={state.company.id
                                    ? "Editar Empresa"
                                    : "Novo Empresa"}
                            >
                                <NewCompanyForm
                                    state={state}
                                    showModal={showModal}
                                    changeInput={changeInput}
                                    changeContactInput={changeContactInput}
                                    changeAddressInput={changeAddressInput}
                                    saveCompany={saveCompany}
                                    displayInputError={displayInputError}
                                />
                            </SimpleConditionalFrame>
                        )
                    }
                ]}
                fallback={(
                    <SimpleGrid
                        mb="20px"
                        columns={{ sm: 1, md: 1 }}
                        spacing={{ base: "20px", xl: "20px" }}
                    >
                        <NewCompanyTable
                            state={state}
                            cancelRef={cancelRef}
                            add={add}
                            closeDelete={closeDelete}
                            editCompany={editCompany}
                            deleteCompany={deleteCompany}
                        />
                    </SimpleGrid>
                )}
            />

            <AlertDialog
                isOpen={state.error}
                leastDestructiveRef={cancelRef}
                onClose={closeError}
                isCentered
                motionPreset="slideInBottom"
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            {state.errorTitle}
                        </AlertDialogHeader>

                        <AlertDialogBody>{state.errorMsg}</AlertDialogBody>

                        <AlertDialogFooter>
                            <Button
                                ref={cancelRef}
                                onClick={closeError}
                                colorScheme={"blue"}
                            >
                                OK
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>
    );
}

export default NewCompaniesScreen;
